import { Toggle } from 'components/toggle/toggle';
import style from './toggle-field.module.scss';

interface ToggleFieldProps {
  id: string;
  value: boolean | null | undefined;
  onChange: (value: boolean) => void;
  onBlur?: () => void;
  labelText?: string;
  disabled?: boolean;
}

export const ToggleField = ({
  id,
  value,
  onChange,
  onBlur,
  labelText,
  disabled,
}: ToggleFieldProps) => {
  return (
    <div id={id} className={style.toggle}>
      <Toggle
        isActive={value ?? false}
        handleToggle={(val: boolean) => {
          onChange(val);
          onBlur?.();
        }}
        disabled={disabled}
      />
      {labelText && <label>{labelText}</label>}
    </div>
  );
};
